import gifImg from 'assets/images/gifs/gifArt.gif'
import { Fade, Slide } from 'react-awesome-reveal'


// ===== About section ========
const About = () => {
    return (
        <section id="about">
            <div className="cs_container">
                <div className="cs_row about_row justify-content-center align-items-center">
                    <div className="about_content">
                        <Fade duration={1100} direction="left" triggerOnce>
                            <p className='font_spaced'>
                                The Space Warriors Club is a collection of 7777 unique 3D NFTs, designed on Unreal Engine 5 stored as ERC-721 on the Ethereum blockchain znf hosted on IPFS. Space Warriors Club aims at building one of the first community-built video game
                            </p>
                            <br />
                        </Fade>
                    </div>
                   <Slide direction='right' duration={1200} triggerOnce>
                   <img className='hero_img' src={gifImg} alt="SPACE WARRIORS CLUB" />
                   </Slide>
                </div>
            </div>
        </section>
    )
}

export default About